const provinceAndCity = [
    {
        name: '北京',
        level: '1',
        code: '110000',
        cities: [
            {
                name: '北京',
                level: '2',
                code: '110100'
            },
            {
                name: '东城区',
                level: '3',
                code: '110101'
            },
            {
                name: '西城区',
                level: '3',
                code: '110102'
            },
            {
                name: '朝阳区',
                level: '3',
                code: '110105'
            },
            {
                name: '丰台区',
                level: '3',
                code: '110106'
            },
            {
                name: '石景山区',
                level: '3',
                code: '110107'
            },
            {
                name: '海淀区',
                level: '3',
                code: '110108'
            },
            {
                name: '门头沟区',
                level: '3',
                code: '110109'
            },
            {
                name: '房山区',
                level: '3',
                code: '110111'
            },
            {
                name: '通州区',
                level: '3',
                code: '110112'
            },
            {
                name: '顺义区',
                level: '3',
                code: '110113'
            },
            {
                name: '昌平区',
                level: '3',
                code: '110114'
            },
            {
                name: '大兴区',
                level: '3',
                code: '110115'
            },
            {
                name: '怀柔区',
                level: '3',
                code: '110116'
            },
            {
                name: '平谷区',
                level: '3',
                code: '110117'
            },
            {
                name: '密云区',
                level: '3',
                code: '110228'
            },
            {
                name: '延庆区',
                level: '3',
                code: '110229'
            }
        ]
    },
    {
        name: '天津',
        level: '1',
        code: '120000',
        cities: [
            {
                name: '天津',
                level: '2',
                code: '120100'
            },
            {
                name: '和平区',
                level: '3',
                code: '120101'
            },
            {
                name: '河东区',
                level: '3',
                code: '120102'
            },
            {
                name: '河西区',
                level: '3',
                code: '120103'
            },
            {
                name: '南开区',
                level: '3',
                code: '120104'
            },
            {
                name: '河北区',
                level: '3',
                code: '120105'
            },
            {
                name: '红桥区',
                level: '3',
                code: '120106'
            },
            {
                name: '东丽区',
                level: '3',
                code: '120110'
            },
            {
                name: '西青区',
                level: '3',
                code: '120111'
            },
            {
                name: '津南区',
                level: '3',
                code: '120112'
            },
            {
                name: '北辰区',
                level: '3',
                code: '120113'
            },
            {
                name: '武清区',
                level: '3',
                code: '120114'
            },
            {
                name: '宝坻区',
                level: '3',
                code: '120115'
            },
            {
                name: '滨海新区',
                level: '3',
                code: '120116'
            },
            {
                name: '宁河区',
                level: '3',
                code: '120117'
            },
            {
                name: '静海区',
                level: '3',
                code: '120118'
            },
            {
                name: '蓟州区',
                level: '3',
                code: '120119'
            }
        ]
    },
    {
        name: '河北',
        level: '1',
        code: '130000',
        cities: [
            {
                name: '石家庄',
                level: '2',
                code: '130100'
            },
            {
                name: '唐山',
                level: '2',
                code: '130200'
            },
            {
                name: '秦皇岛',
                level: '2',
                code: '130300'
            },
            {
                name: '邯郸',
                level: '2',
                code: '130400'
            },
            {
                name: '邢台',
                level: '2',
                code: '130500'
            },
            {
                name: '保定',
                level: '2',
                code: '130600'
            },
            {
                name: '张家口',
                level: '2',
                code: '130700'
            },
            {
                name: '承德',
                level: '2',
                code: '130800'
            },
            {
                name: '沧州',
                level: '2',
                code: '130900'
            },
            {
                name: '廊坊',
                level: '2',
                code: '131000'
            },
            {
                name: '衡水',
                level: '2',
                code: '131100'
            }
        ]
    },
    {
        name: '山西',
        level: '1',
        code: '140000',
        cities: [
            {
                name: '太原',
                level: '2',
                code: '140100'
            },
            {
                name: '大同',
                level: '2',
                code: '140200'
            },
            {
                name: '阳泉',
                level: '2',
                code: '140300'
            },
            {
                name: '长治',
                level: '2',
                code: '140400'
            },
            {
                name: '晋城',
                level: '2',
                code: '140500'
            },
            {
                name: '朔州',
                level: '2',
                code: '140600'
            },
            {
                name: '晋中',
                level: '2',
                code: '140700'
            },
            {
                name: '运城',
                level: '2',
                code: '140800'
            },
            {
                name: '忻州',
                level: '2',
                code: '140900'
            },
            {
                name: '临汾',
                level: '2',
                code: '141000'
            },
            {
                name: '吕梁',
                level: '2',
                code: '141100'
            }
        ]
    },
    {
        name: '内蒙古',
        level: '1',
        code: '150000',
        cities: [
            {
                name: '呼和浩特',
                level: '2',
                code: '150100'
            },
            {
                name: '包头',
                level: '2',
                code: '150200'
            },
            {
                name: '乌海',
                level: '2',
                code: '150300'
            },
            {
                name: '赤峰',
                level: '2',
                code: '150400'
            },
            {
                name: '通辽',
                level: '2',
                code: '150500'
            },
            {
                name: '鄂尔多斯',
                level: '2',
                code: '150600'
            },
            {
                name: '呼伦贝尔',
                level: '2',
                code: '150700'
            },
            {
                name: '巴彦淖尔',
                level: '2',
                code: '150800'
            },
            {
                name: '乌兰察布',
                level: '2',
                code: '150900'
            },
            {
                name: '兴安',
                level: '2',
                code: '152200'
            },
            {
                name: '锡林郭勒',
                level: '2',
                code: '152500'
            },
            {
                name: '阿拉善',
                level: '2',
                code: '152900'
            }
        ]
    },
    {
        name: '辽宁',
        level: '1',
        code: '210000',
        cities: [
            {
                name: '沈阳',
                level: '2',
                code: '210100'
            },
            {
                name: '大连',
                level: '2',
                code: '210200'
            },
            {
                name: '鞍山',
                level: '2',
                code: '210300'
            },
            {
                name: '抚顺',
                level: '2',
                code: '210400'
            },
            {
                name: '本溪',
                level: '2',
                code: '210500'
            },
            {
                name: '丹东',
                level: '2',
                code: '210600'
            },
            {
                name: '锦州',
                level: '2',
                code: '210700'
            },
            {
                name: '营口',
                level: '2',
                code: '210800'
            },
            {
                name: '阜新',
                level: '2',
                code: '210900'
            },
            {
                name: '辽阳',
                level: '2',
                code: '211000'
            },
            {
                name: '盘锦',
                level: '2',
                code: '211100'
            },
            {
                name: '铁岭',
                level: '2',
                code: '211200'
            },
            {
                name: '朝阳',
                level: '2',
                code: '211300'
            },
            {
                name: '葫芦岛',
                level: '2',
                code: '211400'
            }
        ]
    },
    {
        name: '吉林',
        level: '1',
        code: '220000',
        cities: [
            {
                name: '长春',
                level: '2',
                code: '220100'
            },
            {
                name: '吉林',
                level: '2',
                code: '220200'
            },
            {
                name: '四平',
                level: '2',
                code: '220300'
            },
            {
                name: '辽源',
                level: '2',
                code: '220400'
            },
            {
                name: '通化',
                level: '2',
                code: '220500'
            },
            {
                name: '白山',
                level: '2',
                code: '220600'
            },
            {
                name: '松原',
                level: '2',
                code: '220700'
            },
            {
                name: '白城',
                level: '2',
                code: '220800'
            },
            {
                name: '延边',
                level: '2',
                code: '222400'
            }
        ]
    },
    {
        name: '黑龙江',
        level: '1',
        code: '230000',
        cities: [
            {
                name: '哈尔滨',
                level: '2',
                code: '230100'
            },
            {
                name: '齐齐哈尔',
                level: '2',
                code: '230200'
            },
            {
                name: '鸡西',
                level: '2',
                code: '230300'
            },
            {
                name: '鹤岗',
                level: '2',
                code: '230400'
            },
            {
                name: '双鸭山',
                level: '2',
                code: '230500'
            },
            {
                name: '大庆',
                level: '2',
                code: '230600'
            },
            {
                name: '伊春',
                level: '2',
                code: '230700'
            },
            {
                name: '佳木斯',
                level: '2',
                code: '230800'
            },
            {
                name: '七台河',
                level: '2',
                code: '230900'
            },
            {
                name: '牡丹江',
                level: '2',
                code: '231000'
            },
            {
                name: '黑河',
                level: '2',
                code: '231100'
            },
            {
                name: '绥化',
                level: '2',
                code: '231200'
            },
            {
                name: '大兴安岭',
                level: '2',
                code: '232700'
            }
        ]
    },
    {
        name: '上海',
        level: '1',
        code: '310000',
        cities: [
            {
                name: '上海',
                level: '2',
                code: '310100'
            },
            {
                name: '黄浦区',
                level: '3',
                code: '310101'
            },
            {
                name: '徐汇区',
                level: '3',
                code: '310104'
            },
            {
                name: '长宁区',
                level: '3',
                code: '310105'
            },
            {
                name: '静安区',
                level: '3',
                code: '310106'
            },
            {
                name: '普陀区',
                level: '3',
                code: '310107'
            },
            {
                name: '虹口区',
                level: '3',
                code: '310109'
            },
            {
                name: '杨浦区',
                level: '3',
                code: '310110'
            },
            {
                name: '闵行区',
                level: '3',
                code: '310112'
            },
            {
                name: '宝山区',
                level: '3',
                code: '310113'
            },
            {
                name: '嘉定区',
                level: '3',
                code: '310114'
            },
            {
                name: '浦东新区',
                level: '3',
                code: '310115'
            },
            {
                name: '金山区',
                level: '3',
                code: '310116'
            },
            {
                name: '松江区',
                level: '3',
                code: '310117'
            },
            {
                name: '青浦区',
                level: '3',
                code: '310118'
            },
            {
                name: '奉贤区',
                level: '3',
                code: '310120'
            },
            {
                name: '崇明区',
                level: '3',
                code: '310151'
            }
        ]
    },
    {
        name: '江苏',
        level: '1',
        code: '320000',
        cities: [
            {
                name: '南京',
                level: '2',
                code: '320100'
            },
            {
                name: '无锡',
                level: '2',
                code: '320200'
            },
            {
                name: '江阴',
                level: '3',
                code: '320281'
            },
            {
                name: '徐州',
                level: '2',
                code: '320300'
            },
            {
                name: '常州',
                level: '2',
                code: '320400'
            },
            {
                name: '苏州',
                level: '2',
                code: '320500'
            },
            {
                name: '昆山',
                level: '3',
                code: '320583'
            },
            {
                name: '南通',
                level: '2',
                code: '320600'
            },
            {
                name: '连云港',
                level: '2',
                code: '320700'
            },
            {
                name: '淮安',
                level: '2',
                code: '320800'
            },
            {
                name: '盐城',
                level: '2',
                code: '320900'
            },
            {
                name: '扬州',
                level: '2',
                code: '321000'
            },
            {
                name: '镇江',
                level: '2',
                code: '321100'
            },
            {
                name: '泰州',
                level: '2',
                code: '321200'
            },
            {
                name: '宿迁',
                level: '2',
                code: '321300'
            }
        ]
    },
    {
        name: '浙江',
        level: '1',
        code: '330000',
        cities: [
            {
                name: '杭州',
                level: '2',
                code: '330100'
            },
            {
                name: '宁波',
                level: '2',
                code: '330200'
            },
            {
                name: '温州',
                level: '2',
                code: '330300'
            },
            {
                name: '嘉兴',
                level: '2',
                code: '330400'
            },
            {
                name: '湖州',
                level: '2',
                code: '330500'
            },
            {
                name: '绍兴',
                level: '2',
                code: '330600'
            },
            {
                name: '金华',
                level: '2',
                code: '330700'
            },
            {
                name: '衢州',
                level: '2',
                code: '330800'
            },
            {
                name: '舟山',
                level: '2',
                code: '330900'
            },
            {
                name: '台州',
                level: '2',
                code: '331000'
            },
            {
                name: '丽水',
                level: '2',
                code: '331100'
            },
            {
                name: '海宁',
                level: '2',
                code: '331200'
            }
        ]
    },
    {
        name: '安徽',
        level: '1',
        code: '340000',
        cities: [
            {
                name: '合肥',
                level: '2',
                code: '340100'
            },
            {
                name: '芜湖',
                level: '2',
                code: '340200'
            },
            {
                name: '蚌埠',
                level: '2',
                code: '340300'
            },
            {
                name: '淮南',
                level: '2',
                code: '340400'
            },
            {
                name: '马鞍山',
                level: '2',
                code: '340500'
            },
            {
                name: '淮北',
                level: '2',
                code: '340600'
            },
            {
                name: '铜陵',
                level: '2',
                code: '340700'
            },
            {
                name: '安庆',
                level: '2',
                code: '340800'
            },
            {
                name: '黄山',
                level: '2',
                code: '341000'
            },
            {
                name: '滁州',
                level: '2',
                code: '341100'
            },
            {
                name: '阜阳',
                level: '2',
                code: '341200'
            },
            {
                name: '宿州',
                level: '2',
                code: '341300'
            },
            {
                name: '六安',
                level: '2',
                code: '341500'
            },
            {
                name: '亳州',
                level: '2',
                code: '341600'
            },
            {
                name: '池州',
                level: '2',
                code: '341700'
            },
            {
                name: '宣城',
                level: '2',
                code: '341800'
            }
        ]
    },
    {
        name: '福建',
        level: '1',
        code: '350000',
        cities: [
            {
                name: '福州',
                level: '2',
                code: '350100'
            },
            {
                name: '厦门',
                level: '2',
                code: '350200'
            },
            {
                name: '莆田',
                level: '2',
                code: '350300'
            },
            {
                name: '三明',
                level: '2',
                code: '350400'
            },
            {
                name: '泉州',
                level: '2',
                code: '350500'
            },
            {
                name: '漳州',
                level: '2',
                code: '350600'
            },
            {
                name: '南平',
                level: '2',
                code: '350700'
            },
            {
                name: '龙岩',
                level: '2',
                code: '350800'
            },
            {
                name: '宁德',
                level: '2',
                code: '350900'
            }
        ]
    },
    {
        name: '江西',
        level: '1',
        code: '360000',
        cities: [
            {
                name: '南昌',
                level: '2',
                code: '360100'
            },
            {
                name: '景德镇',
                level: '2',
                code: '360200'
            },
            {
                name: '萍乡',
                level: '2',
                code: '360300'
            },
            {
                name: '九江',
                level: '2',
                code: '360400'
            },
            {
                name: '新余',
                level: '2',
                code: '360500'
            },
            {
                name: '鹰潭',
                level: '2',
                code: '360600'
            },
            {
                name: '赣州',
                level: '2',
                code: '360700'
            },
            {
                name: '吉安',
                level: '2',
                code: '360800'
            },
            {
                name: '宜春',
                level: '2',
                code: '360900'
            },
            {
                name: '抚州',
                level: '2',
                code: '361000'
            },
            {
                name: '上饶',
                level: '2',
                code: '361100'
            }
        ]
    },
    {
        name: '山东',
        level: '1',
        code: '370000',
        cities: [
            {
                name: '济南',
                level: '2',
                code: '370100'
            },
            {
                name: '青岛',
                level: '2',
                code: '370200'
            },
            {
                name: '淄博',
                level: '2',
                code: '370300'
            },
            {
                name: '枣庄',
                level: '2',
                code: '370400'
            },
            {
                name: '东营',
                level: '2',
                code: '370500'
            },
            {
                name: '烟台',
                level: '2',
                code: '370600'
            },
            {
                name: '潍坊',
                level: '2',
                code: '370700'
            },
            {
                name: '济宁',
                level: '2',
                code: '370800'
            },
            {
                name: '泰安',
                level: '2',
                code: '370900'
            },
            {
                name: '威海',
                level: '2',
                code: '371000'
            },
            {
                name: '日照',
                level: '2',
                code: '371100'
            },
            {
                name: '莱芜',
                level: '2',
                code: '371200'
            },
            {
                name: '临沂',
                level: '2',
                code: '371300'
            },
            {
                name: '德州',
                level: '2',
                code: '371400'
            },
            {
                name: '聊城',
                level: '2',
                code: '371500'
            },
            {
                name: '滨州',
                level: '2',
                code: '371600'
            },
            {
                name: '菏泽',
                level: '2',
                code: '371700'
            }
        ]
    },
    {
        name: '河南',
        level: '1',
        code: '410000',
        cities: [
            {
                name: '郑州',
                level: '2',
                code: '410100'
            },
            {
                name: '开封',
                level: '2',
                code: '410200'
            },
            {
                name: '洛阳',
                level: '2',
                code: '410300'
            },
            {
                name: '平顶山',
                level: '2',
                code: '410400'
            },
            {
                name: '安阳',
                level: '2',
                code: '410500'
            },
            {
                name: '鹤壁',
                level: '2',
                code: '410600'
            },
            {
                name: '新乡',
                level: '2',
                code: '410700'
            },
            {
                name: '焦作',
                level: '2',
                code: '410800'
            },
            {
                name: '濮阳',
                level: '2',
                code: '410900'
            },
            {
                name: '许昌',
                level: '2',
                code: '411000'
            },
            {
                name: '漯河',
                level: '2',
                code: '411100'
            },
            {
                name: '三门峡',
                level: '2',
                code: '411200'
            },
            {
                name: '南阳',
                level: '2',
                code: '411300'
            },
            {
                name: '商丘',
                level: '2',
                code: '411400'
            },
            {
                name: '信阳',
                level: '2',
                code: '411500'
            },
            {
                name: '周口',
                level: '2',
                code: '411600'
            },
            {
                name: '驻马店',
                level: '2',
                code: '411700'
            },
            {
                name: '直辖县',
                level: '2',
                code: '419000'
            }
        ]
    },
    {
        name: '湖北',
        level: '1',
        code: '420000',
        cities: [
            {
                name: '武汉',
                level: '2',
                code: '420100'
            },
            {
                name: '黄石',
                level: '2',
                code: '420200'
            },
            {
                name: '十堰',
                level: '2',
                code: '420300'
            },
            {
                name: '宜昌',
                level: '2',
                code: '420500'
            },
            {
                name: '襄阳',
                level: '2',
                code: '420600'
            },
            {
                name: '鄂州',
                level: '2',
                code: '420700'
            },
            {
                name: '荆门',
                level: '2',
                code: '420800'
            },
            {
                name: '孝感',
                level: '2',
                code: '420900'
            },
            {
                name: '荆州',
                level: '2',
                code: '421000'
            },
            {
                name: '黄冈',
                level: '2',
                code: '421100'
            },
            {
                name: '咸宁',
                level: '2',
                code: '421200'
            },
            {
                name: '随州',
                level: '2',
                code: '421300'
            },
            {
                name: '恩施',
                level: '2',
                code: '422800'
            },
            {
                name: '直辖县',
                level: '2',
                code: '429000'
            },
            {
                name: '天门',
                level: '3',
                code: '429001'
            },
            {
                name: '潜江',
                level: '3',
                code: '429005'
            }
        ]
    },
    {
        name: '湖南',
        level: '1',
        code: '430000',
        cities: [
            {
                name: '长沙',
                level: '2',
                code: '430100'
            },
            {
                name: '株洲',
                level: '2',
                code: '430200'
            },
            {
                name: '湘潭',
                level: '2',
                code: '430300'
            },
            {
                name: '衡阳',
                level: '2',
                code: '430400'
            },
            {
                name: '邵阳',
                level: '2',
                code: '430500'
            },
            {
                name: '岳阳',
                level: '2',
                code: '430600'
            },
            {
                name: '常德',
                level: '2',
                code: '430700'
            },
            {
                name: '张家界',
                level: '2',
                code: '430800'
            },
            {
                name: '益阳',
                level: '2',
                code: '430900'
            },
            {
                name: '郴州',
                level: '2',
                code: '431000'
            },
            {
                name: '永州',
                level: '2',
                code: '431100'
            },
            {
                name: '怀化',
                level: '2',
                code: '431200'
            },
            {
                name: '娄底',
                level: '2',
                code: '431300'
            },
            {
                name: '湘西',
                level: '2',
                code: '433100'
            }
        ]
    },
    {
        name: '广东',
        level: '1',
        code: '440000',
        cities: [
            {
                name: '广州',
                level: '2',
                code: '440100'
            },
            {
                name: '韶关',
                level: '2',
                code: '440200'
            },
            {
                name: '深圳',
                level: '2',
                code: '440300'
            },
            {
                name: '珠海',
                level: '2',
                code: '440400'
            },
            {
                name: '汕头',
                level: '2',
                code: '440500'
            },
            {
                name: '佛山',
                level: '2',
                code: '440600'
            },
            {
                name: '江门',
                level: '2',
                code: '440700'
            },
            {
                name: '湛江',
                level: '2',
                code: '440800'
            },
            {
                name: '茂名',
                level: '2',
                code: '440900'
            },
            {
                name: '肇庆',
                level: '2',
                code: '441200'
            },
            {
                name: '惠州',
                level: '2',
                code: '441300'
            },
            {
                name: '梅州',
                level: '2',
                code: '441400'
            },
            {
                name: '汕尾',
                level: '2',
                code: '441500'
            },
            {
                name: '河源',
                level: '2',
                code: '441600'
            },
            {
                name: '阳江',
                level: '2',
                code: '441700'
            },
            {
                name: '清远',
                level: '2',
                code: '441800'
            },
            {
                name: '东莞',
                level: '2',
                code: '441900'
            },
            {
                name: '中山',
                level: '2',
                code: '442000'
            },
            {
                name: '潮州',
                level: '2',
                code: '445100'
            },
            {
                name: '揭阳',
                level: '2',
                code: '445200'
            },
            {
                name: '云浮',
                level: '2',
                code: '445300'
            }
        ]
    },
    {
        name: '广西',
        level: '1',
        code: '450000',
        cities: [
            {
                name: '南宁',
                level: '2',
                code: '450100'
            },
            {
                name: '柳州',
                level: '2',
                code: '450200'
            },
            {
                name: '桂林',
                level: '2',
                code: '450300'
            },
            {
                name: '梧州',
                level: '2',
                code: '450400'
            },
            {
                name: '北海',
                level: '2',
                code: '450500'
            },
            {
                name: '防城港',
                level: '2',
                code: '450600'
            },
            {
                name: '钦州',
                level: '2',
                code: '450700'
            },
            {
                name: '贵港',
                level: '2',
                code: '450800'
            },
            {
                name: '玉林',
                level: '2',
                code: '450900'
            },
            {
                name: '百色',
                level: '2',
                code: '451000'
            },
            {
                name: '贺州',
                level: '2',
                code: '451100'
            },
            {
                name: '河池',
                level: '2',
                code: '451200'
            },
            {
                name: '来宾',
                level: '2',
                code: '451300'
            },
            {
                name: '崇左',
                level: '2',
                code: '451400'
            }
        ]
    },
    {
        name: '海南',
        level: '1',
        code: '460000',
        cities: [
            {
                name: '海口',
                level: '2',
                code: '460100'
            },
            {
                name: '三亚',
                level: '2',
                code: '460200'
            },
            {
                name: '三沙',
                level: '2',
                code: '460300'
            },
            {
                name: '儋州',
                level: '3',
                code: '466410'
            },
            {
                name: '直辖县',
                level: '2',
                code: '469000'
            },
            {
                name: '陵水',
                level: '3',
                code: '469001'
            }
        ]
    },
    {
        name: '重庆',
        level: '1',
        code: '500000',
        cities: [
            {
                name: '重庆',
                level: '2',
                code: '500100'
            },
            {
                name: '万州区',
                level: '3',
                code: '500101'
            },
            {
                name: '涪陵区',
                level: '3',
                code: '500102'
            },
            {
                name: '渝中区',
                level: '3',
                code: '500103'
            },
            {
                name: '大渡口区',
                level: '3',
                code: '500104'
            },
            {
                name: '江北区',
                level: '3',
                code: '500105'
            },
            {
                name: '沙坪坝区',
                level: '3',
                code: '500106'
            },
            {
                name: '九龙坡区',
                level: '3',
                code: '500107'
            },
            {
                name: '南岸区',
                level: '3',
                code: '500108'
            },
            {
                name: '北碚区',
                level: '3',
                code: '500109'
            },
            {
                name: '綦江区',
                level: '3',
                code: '500110'
            },
            {
                name: '大足区',
                level: '3',
                code: '500111'
            },
            {
                name: '渝北区',
                level: '3',
                code: '500112'
            },
            {
                name: '巴南区',
                level: '3',
                code: '500113'
            },
            {
                name: '黔江区',
                level: '3',
                code: '500114'
            },
            {
                name: '长寿区',
                level: '3',
                code: '500115'
            },
            {
                name: '江津区',
                level: '3',
                code: '500116'
            },
            {
                name: '合川区',
                level: '3',
                code: '500117'
            },
            {
                name: '永川区',
                level: '3',
                code: '500118'
            },
            {
                name: '南川区',
                level: '3',
                code: '500119'
            },
            {
                name: '璧山区',
                level: '3',
                code: '500120'
            },
            {
                name: '铜梁区',
                level: '3',
                code: '500151'
            },
            {
                name: '潼南区',
                level: '3',
                code: '500152'
            },
            {
                name: '荣昌区',
                level: '3',
                code: '500153'
            },
            {
                name: '开州区',
                level: '3',
                code: '500154'
            },
            {
                name: '梁平区',
                level: '3',
                code: '500155'
            },
            {
                name: '武隆区',
                level: '3',
                code: '500156'
            },
            {
                name: '忠县',
                level: '3',
                code: '500157'
            }
        ]
    },
    {
        name: '四川',
        level: '1',
        code: '510000',
        cities: [
            {
                name: '成都',
                level: '2',
                code: '510100'
            },
            {
                name: '自贡',
                level: '2',
                code: '510300'
            },
            {
                name: '攀枝花',
                level: '2',
                code: '510400'
            },
            {
                name: '泸州',
                level: '2',
                code: '510500'
            },
            {
                name: '德阳',
                level: '2',
                code: '510600'
            },
            {
                name: '绵阳',
                level: '2',
                code: '510700'
            },
            {
                name: '广元',
                level: '2',
                code: '510800'
            },
            {
                name: '遂宁',
                level: '2',
                code: '510900'
            },
            {
                name: '内江',
                level: '2',
                code: '511000'
            },
            {
                name: '乐山',
                level: '2',
                code: '511100'
            },
            {
                name: '南充',
                level: '2',
                code: '511300'
            },
            {
                name: '眉山',
                level: '2',
                code: '511400'
            },
            {
                name: '宜宾',
                level: '2',
                code: '511500'
            },
            {
                name: '广安',
                level: '2',
                code: '511600'
            },
            {
                name: '达州',
                level: '2',
                code: '511700'
            },
            {
                name: '雅安',
                level: '2',
                code: '511800'
            },
            {
                name: '巴中',
                level: '2',
                code: '511900'
            },
            {
                name: '资阳',
                level: '2',
                code: '512000'
            },
            {
                name: '阿坝',
                level: '2',
                code: '513200'
            },
            {
                name: '甘孜',
                level: '2',
                code: '513300'
            },
            {
                name: '凉山',
                level: '2',
                code: '513400'
            }
        ]
    },
    {
        name: '贵州',
        level: '1',
        code: '520000',
        cities: [
            {
                name: '贵阳',
                level: '2',
                code: '520100'
            },
            {
                name: '六盘水',
                level: '2',
                code: '520200'
            },
            {
                name: '遵义',
                level: '2',
                code: '520300'
            },
            {
                name: '安顺',
                level: '2',
                code: '520400'
            },
            {
                name: '毕节',
                level: '2',
                code: '520500'
            },
            {
                name: '铜仁',
                level: '2',
                code: '520600'
            },
            {
                name: '黔西南',
                level: '2',
                code: '522300'
            },
            {
                name: '黔东南',
                level: '2',
                code: '522600'
            },
            {
                name: '黔南',
                level: '2',
                code: '522700'
            }
        ]
    },
    {
        name: '云南',
        level: '1',
        code: '530000',
        cities: [
            {
                name: '昆明',
                level: '2',
                code: '530100'
            },
            {
                name: '曲靖',
                level: '2',
                code: '530300'
            },
            {
                name: '玉溪',
                level: '2',
                code: '530400'
            },
            {
                name: '保山',
                level: '2',
                code: '530500'
            },
            {
                name: '昭通',
                level: '2',
                code: '530600'
            },
            {
                name: '丽江',
                level: '2',
                code: '530700'
            },
            {
                name: '普洱',
                level: '2',
                code: '530800'
            },
            {
                name: '临沧',
                level: '2',
                code: '530900'
            },
            {
                name: '楚雄',
                level: '2',
                code: '532300'
            },
            {
                name: '红河',
                level: '2',
                code: '532500'
            },
            {
                name: '文山',
                level: '2',
                code: '532600'
            },
            {
                name: '西双版纳',
                level: '2',
                code: '532800'
            },
            {
                name: '大理',
                level: '2',
                code: '532900'
            },
            {
                name: '德宏',
                level: '2',
                code: '533100'
            },
            {
                name: '怒江',
                level: '2',
                code: '533300'
            },
            {
                name: '迪庆',
                level: '2',
                code: '533400'
            }
        ]
    },
    {
        name: '西藏',
        level: '1',
        code: '540000',
        cities: [
            {
                name: '拉萨',
                level: '2',
                code: '540100'
            },
            {
                name: '日喀则',
                level: '2',
                code: '540200'
            },
            {
                name: '昌都',
                level: '2',
                code: '542100'
            },
            {
                name: '山南',
                level: '2',
                code: '542200'
            },
            {
                name: '那曲',
                level: '2',
                code: '542400'
            },
            {
                name: '阿里',
                level: '2',
                code: '542500'
            },
            {
                name: '林芝',
                level: '2',
                code: '542600'
            }
        ]
    },
    {
        name: '陕西',
        level: '1',
        code: '610000',
        cities: [
            {
                name: '西安',
                level: '2',
                code: '610100'
            },
            {
                name: '铜川',
                level: '2',
                code: '610200'
            },
            {
                name: '宝鸡',
                level: '2',
                code: '610300'
            },
            {
                name: '咸阳',
                level: '2',
                code: '610400'
            },
            {
                name: '渭南',
                level: '2',
                code: '610500'
            },
            {
                name: '延安',
                level: '2',
                code: '610600'
            },
            {
                name: '汉中',
                level: '2',
                code: '610700'
            },
            {
                name: '榆林',
                level: '2',
                code: '610800'
            },
            {
                name: '安康',
                level: '2',
                code: '610900'
            },
            {
                name: '商洛',
                level: '2',
                code: '611000'
            }
        ]
    },
    {
        name: '甘肃',
        level: '1',
        code: '620000',
        cities: [
            {
                name: '兰州',
                level: '2',
                code: '620100'
            },
            {
                name: '嘉峪关',
                level: '2',
                code: '620200'
            },
            {
                name: '金昌',
                level: '2',
                code: '620300'
            },
            {
                name: '白银',
                level: '2',
                code: '620400'
            },
            {
                name: '天水',
                level: '2',
                code: '620500'
            },
            {
                name: '武威',
                level: '2',
                code: '620600'
            },
            {
                name: '张掖',
                level: '2',
                code: '620700'
            },
            {
                name: '平凉',
                level: '2',
                code: '620800'
            },
            {
                name: '酒泉',
                level: '2',
                code: '620900'
            },
            {
                name: '庆阳',
                level: '2',
                code: '621000'
            },
            {
                name: '定西',
                level: '2',
                code: '621100'
            },
            {
                name: '陇南',
                level: '2',
                code: '621200'
            },
            {
                name: '临夏',
                level: '2',
                code: '622900'
            },
            {
                name: '甘南',
                level: '2',
                code: '623000'
            }
        ]
    },
    {
        name: '青海',
        level: '1',
        code: '630000',
        cities: [
            {
                name: '西宁',
                level: '2',
                code: '630100'
            },
            {
                name: '海东',
                level: '2',
                code: '630200'
            },
            {
                name: '海北',
                level: '2',
                code: '632200'
            },
            {
                name: '黄南',
                level: '2',
                code: '632300'
            },
            {
                name: '海南',
                level: '2',
                code: '632500'
            },
            {
                name: '果洛',
                level: '2',
                code: '632600'
            },
            {
                name: '玉树',
                level: '2',
                code: '632700'
            },
            {
                name: '海西',
                level: '2',
                code: '632800'
            }
        ]
    },
    {
        name: '宁夏',
        level: '1',
        code: '640000',
        cities: [
            {
                name: '银川',
                level: '2',
                code: '640100'
            },
            {
                name: '石嘴山',
                level: '2',
                code: '640200'
            },
            {
                name: '吴忠',
                level: '2',
                code: '640300'
            },
            {
                name: '固原',
                level: '2',
                code: '640400'
            },
            {
                name: '中卫',
                level: '2',
                code: '640500'
            }
        ]
    },
    {
        name: '新疆',
        level: '1',
        code: '650000',
        cities: [
            {
                name: '乌鲁木齐',
                level: '2',
                code: '650100'
            },
            {
                name: '克拉玛依',
                level: '2',
                code: '650200'
            },
            {
                name: '吐鲁番',
                level: '2',
                code: '652100'
            },
            {
                name: '哈密',
                level: '2',
                code: '652200'
            },
            {
                name: '昌吉',
                level: '2',
                code: '652300'
            },
            {
                name: '博尔塔拉',
                level: '2',
                code: '652700'
            },
            {
                name: '巴音郭楞',
                level: '2',
                code: '652800'
            },
            {
                name: '阿克苏',
                level: '2',
                code: '652900'
            },
            {
                name: '克孜勒苏',
                level: '2',
                code: '653000'
            },
            {
                name: '喀什',
                level: '2',
                code: '653100'
            },
            {
                name: '和田',
                level: '2',
                code: '653200'
            },
            {
                name: '伊犁',
                level: '2',
                code: '654000'
            },
            {
                name: '塔城',
                level: '2',
                code: '654200'
            },
            {
                name: '阿勒泰',
                level: '2',
                code: '654300'
            },
            {
                name: '直辖县',
                level: '2',
                code: '659000'
            },
            {
                name: '新星',
                level: '3',
                code: '659011'
            },
            {
                name: '石河子',
                level: '3',
                code: '659012'
            },
            {
                name: '铁门关',
                level: '3',
                code: '659013'
            },
            {
                name: '五家渠',
                level: '3',
                code: '659014'
            },
            {
                name: '阿拉尔',
                level: '3',
                code: '659015'
            },
            {
                name: '昆玉',
                level: '3',
                code: '659016'
            },
            {
                name: '可克达拉',
                level: '3',
                code: '659017'
            },
            {
                name: '图木舒克',
                level: '3',
                code: '659018'
            },
            {
                name: '双河',
                level: '3',
                code: '659019'
            }
        ]
    },
    {
        name: '香港',
        level: '1',
        code: '999077',
        cities: [
            {
                name: '香港岛',
                level: '3',
                code: '99907701'
            },
            {
                name: '九龙半岛',
                level: '3',
                code: '99907702'
            },
            {
                name: '新界',
                level: '3',
                code: '99907703'
            },
            {
                name: '中西区',
                level: '3',
                code: '9990770101'
            },
            {
                name: '湾仔区',
                level: '3',
                code: '9990770102'
            },
            {
                name: '东区',
                level: '3',
                code: '9990770103'
            },
            {
                name: '南区',
                level: '3',
                code: '9990770104'
            },
            {
                name: '观塘区',
                level: '3',
                code: '9990770201'
            },
            {
                name: '黄大仙区',
                level: '3',
                code: '9990770202'
            },
            {
                name: '深水埗区',
                level: '3',
                code: '9990770203'
            },
            {
                name: '油尖旺区',
                level: '3',
                code: '9990770204'
            },
            {
                name: '九龙城区',
                level: '3',
                code: '9990770205'
            },
            {
                name: '离岛区',
                level: '3',
                code: '9990770301'
            },
            {
                name: '葵青区',
                level: '3',
                code: '9990770302'
            },
            {
                name: '元朗区',
                level: '3',
                code: '9990770303'
            },
            {
                name: '西贡区',
                level: '3',
                code: '9990770304'
            },
            {
                name: '大埔区',
                level: '3',
                code: '9990770305'
            },
            {
                name: '屯门区',
                level: '3',
                code: '9990770306'
            },
            {
                name: '荃湾区',
                level: '3',
                code: '9990770307'
            },
            {
                name: '北区‌',
                level: '3',
                code: '9990770308'
            },
            {
                name: '沙田区',
                level: '3',
                code: '9990770309'
            }
        ]
    },
    {
        name: '澳门',
        level: '1',
        code: '999078',
        cities: [
            {
                name: '离岛',
                level: '3',
                code: '99907801'
            },
            {
                name: '半岛',
                level: '3',
                code: '99907802'
            },
            {
                name: '嘉模堂区‌',
                level: '3',
                code: '9990780101'
            },
            {
                name: '‌圣方济各堂区',
                level: '3',
                code: '9990780102'
            },
            {
                name: '‌花地玛堂区',
                level: '3',
                code: '9990780201'
            },
            {
                name: '圣安多尼堂区‌',
                level: '3',
                code: '9990780202'
            },
            {
                name: '大堂区‌',
                level: '3',
                code: '9990780203'
            },
            {
                name: '望德堂区‌',
                level: '3',
                code: '9990780204'
            },
            {
                name: '‌风顺堂区',
                level: '3',
                code: '9990780205'
            }
        ]
    },
    {
        name: '国外',
        level: '1',
        code: '999999',
        cities: [
            {
                name: '国外',
                level: '3',
                code: '999999'
            }
        ]
    }
]
export default {
    provinceAndCity
}



// WEBPACK FOOTER //
// ./src/components/CommonData/provinceAndCity.js